import './filters.css';
import Flaticon from "../flaticon/flaticon";
import {convertToSlug} from '../../utils/utils'
import RangeChoice from "../rangeChoice/rangeChoice";
import {useEffect, useRef, useState} from "react";

function Filters(props) {
    //INIT VAR
    const dataFilterTag = typeof props.dataFilterTag !== "undefined" ? props.dataFilterTag : [];
    const activeFilterList = typeof props.activeFilterList !== "undefined" ? props.activeFilterList : false;
    const handleFilterClick = typeof props.handleFilterClick !== "undefined" ? props.handleFilterClick : false;
    const handleRangeChange = typeof props.handleRangeChange !== "undefined" ? props.handleRangeChange : false;
    const handleRangeUp = typeof props.handleRangeUp !== "undefined" ? props.handleRangeUp : false;
    const rangeValue = typeof props.rangeValue !== "undefined" ? props.rangeValue : false;
    const [filterOpened, setFilterOpened] = useState(false);

    useEffect(()=>{
        document.addEventListener('mousedown',handleFilterButtonOutsideClick)
        return function clean() {
            document.removeEventListener('mousedown',handleFilterButtonOutsideClick)
        }
    },[filterOpened])

    const buttonFilter = useRef()
    const handleFilterButtonClick = (e) => {

        buttonFilter.current.classList.toggle('filter-bar-open')
        setFilterOpened(!filterOpened)

    }

    const handleFilterButtonOutsideClick = (e) => {

        if (buttonFilter && !buttonFilter.current.contains(e.target)) {

            if (buttonFilter.current.classList.contains('filter-bar-open')){
                buttonFilter.current.classList.toggle('filter-bar-open')
                if (filterOpened)
                    setFilterOpened(false)
            }

        }

    }

    return (
        <div ref={buttonFilter} className={'filter-bar'}>
            <button onClick={handleFilterButtonClick} className={'filter-bar-link slo-btn'}>Filtres <Flaticon icon={!filterOpened ? 'down-chevron' : 'close'}/></button>
            <form className={'filter-bar-form'} action="">
                <div className={'filter-bar-form-container'}>
                    {<RangeChoice className={'header-item'} handleRangeUp={handleRangeUp} handleRangeChange={handleRangeChange} value={rangeValue ? rangeValue : 10}/>}
                    {dataFilterTag.length !== 0 ? dataFilterTag.map((object,index) => {
                        return (
                            <div key={'select-filter'+index} className={`filter-bar-form-container-item ${activeFilterList.findIndex((e)=>(e.label === object.label)) !== -1 ? 'checked' : ''}`}>
                                <label className={'filter-bar-form-container-item-label'} htmlFor={'checkbox-'+convertToSlug(object.label)}>
                                    {activeFilterList.findIndex((e)=>(e.label === object.label)) !== -1 ?
                                    <Flaticon icon={'check-symbol'}/>
                                    :
                                    <Flaticon icon={'close'}/>
                                }
                                    <input checked={activeFilterList.findIndex((e)=>(e.label === object.label)) !== -1} onChange={handleFilterClick} name={object.label} id={'checkbox-'+convertToSlug(object.label)} type={'checkbox'}/>
                                    <div className={'filter-bar-form-container-item-label-text'}>{object.label[0].toUpperCase() + object.label.substring(1)} { typeof object.count !== "undefined" ? `(${object.count})` : ''}</div>
                                </label>
                            </div>
                        )
                    }) : <div className={'filter-bar-form-container-item'}>Chargement des filtres...</div>}
                </div>
            </form>

        </div>
    );
}

export default Filters;
